import React, { useEffect, useState } from "react";
import { Text, View, StyleSheet, Platform } from "react-native";

import { durationToHHmm } from "../../../helpers/utils";
import AppTheme from "../AppTheme";

export default function ManaHHmm({ duration }) {
  const [time, setTime] = useState({});

  useEffect(() => {
    setTime(durationToHHmm(duration || 0));
  }, [duration]);

  return (
    <View style={styles.row}>
      <Text style={styles.time}>(</Text>
      {time.hours > 0 ? (
        <>
          <Text style={styles.time}>{time.hours}</Text>
          <Text style={styles.label}>h</Text>
        </>
      ) : null}
      {time.minutes > 0 ? (
        <>
          <Text style={styles.time}>{time.minutes}</Text>
          <Text style={styles.label}>m</Text>
        </>
      ) : null}
      <Text style={styles.time}>)</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  time: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.title,
  },
  label: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    textTransform: "lowercase",
    paddingTop: 5,
    color: AppTheme.title,
  },
});
